import { render, staticRenderFns } from "./GlobalSelector.vue?vue&type=template&id=b615145c&scoped=true"
import script from "./GlobalSelector.vue?vue&type=script&lang=js"
export * from "./GlobalSelector.vue?vue&type=script&lang=js"
import style0 from "./GlobalSelector.vue?vue&type=style&index=0&id=b615145c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b615145c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/minhochoi/projects/MAPPING/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b615145c')) {
      api.createRecord('b615145c', component.options)
    } else {
      api.reload('b615145c', component.options)
    }
    module.hot.accept("./GlobalSelector.vue?vue&type=template&id=b615145c&scoped=true", function () {
      api.rerender('b615145c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GlobalSelector.vue"
export default component.exports